import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDashboardNewBusinessModalOpen } from '../redux/ducks/UIDucks';
import type { RootReducerType } from '../redux/reducers/RootReducer.types';

interface DashboardNewBusinessModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useDashboardNewBusinessModal = (): DashboardNewBusinessModalStore => {
  const dispatch = useDispatch();

  const modalIsOpen = useSelector(
    (state: RootReducerType) => state.ui.isDashboardNewBusinessModalOpen,
  );

  const onOpen = useCallback(() => {
    dispatch(setDashboardNewBusinessModalOpen(true));
  }, []);

  const onClose = useCallback(() => {
    dispatch(setDashboardNewBusinessModalOpen(false));
  }, []);

  return {
    isOpen: modalIsOpen,
    onOpen,
    onClose,
  };
};

export default useDashboardNewBusinessModal;
